import { type Meta } from '../types/docs';
import { AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM } from './automationsAnalytics';

const META: Meta = {
  description: 'The user requests a test run of an automation',
  name: 'automation_test_run_requested',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation to test',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
